import { computed, signal } from "@preact/signals-react"

export const productDetailsEvolutionsAllData = signal({})
export const isLoadingProductDetailsEvolution = signal(true)
export const productDetailsEvolutionAllSellers = signal({})
export const productDetailsEvolutionSkuData = signal([])
export const productDetailsEvolutionSelectedSku = signal(null)

//Computed
export const productDetailsEvolutionOptionsSku = computed(() =>
	productDetailsEvolutionSkuData.value.map(({ sku, skuID }) =>({
		label: sku, value: skuID
	}))
)
export const productDetailsEvolutionCurrentSkuData = computed(() =>
	productDetailsEvolutionSkuData.value.filter(({ skuID }) => skuID === productDetailsEvolutionSelectedSku.value)[0] || {}
)
export const productDetailsEvolutionCurrentData = computed(() =>
	productDetailsEvolutionsAllData.value[productDetailsEvolutionSelectedSku.value] || []
)
export const productDetailsEvolutionCurrentSellers = computed(() =>
	productDetailsEvolutionAllSellers.value[productDetailsEvolutionSelectedSku.value] || []
)